import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      const publicPaths = [
        "/login",
        "/forgot-password",
        "/security-question-login",
        "/reset-password",
      ];
      const currentPath = window.location.pathname;

      // Only redirect if NOT on a public auth page
      if (!publicPaths.some((path) => currentPath.startsWith(path))) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
